import { createFileRoute } from '@tanstack/react-router'

import { RequestTriageScreen } from './-components/request-triage-screen.tsx'

export const Route = createFileRoute('/product/request-triage')({
  component: RequestTriageScreen
})
